// extracted by mini-css-extract-plugin
export var bodySections = "_7a-8";
export var gray = "_7a-7";
export var green = "_7a-4";
export var iconContainer = "_7a-9";
export var iconWidgetContainer = "_7a-1";
export var phoneIcon = "_7a-2";
export var red = "_7a-5";
export var statusDot = "_7a-3";
export var widgetContainer = "_7a-0";
export var yellow = "_7a-6";